import FormUrls from '../constants/formUrls';
import axios from 'axios';

class FormApiService {
  getForm(id) {
    return axios.get(`${FormUrls.form}${id}`);
  }

  getOldestEzyForms(organizationId) {
    return axios.get(`${FormUrls.oldestEzyForms}${organizationId}`);
  }
}

export default new FormApiService();
